import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { StudioProvider } from "./studioStore";
import { applyGeoLanguage } from "./i18n";
import "./styles.css";
import "./ai.css";

void applyGeoLanguage();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StudioProvider>
      <App />
    </StudioProvider>
  </StrictMode>,
);
